import { type SearchPreloadDataProvider } from '../../../common/types/search-preload';

export function getPreloadedQueryVars({
	cloudId,
	preloadDataProvider,
}: {
	cloudId?: string;
	preloadDataProvider?: SearchPreloadDataProvider;
}): {
	source: string | undefined;
	searchResultsQueryVariables: {
		[x: string]: unknown;
	} | null;
	rightPanelQueryVariables: {
		[x: string]: unknown;
	} | null;
} | null {
	if (!cloudId || !preloadDataProvider) {
		return null;
	}

	const preloadedSearch = preloadDataProvider.getPreloadedSearch({ cloudId });
	const source = preloadedSearch?.source;
	const searchResultsQueryVariables = preloadedSearch?.search?.queryVariables ?? null;
	const rightPanelQueryVariables = preloadedSearch?.rightPanel?.queryVariables ?? null;

	if (!searchResultsQueryVariables && !rightPanelQueryVariables) {
		return null;
	}

	return {
		source,
		searchResultsQueryVariables,
		rightPanelQueryVariables,
	};
}
